import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import ratingRoutes from '@/Ratings/router'
import applicationRoutes from '@/Applications/router'
import moderationRoutes from '@/Moderation/router'
import { notAuthGuard, authGuard } from './guards'

const routes: Array<RouteRecordRaw> = process.env.MAINTENANCE_MODE === '1' ? [
    {
        path: '/:path(.*)',
        component: () => import('../views/Maintenance/Maintenance.vue'),
    }] : [
    {
        path: '/',
        component: () => import('../wrappers/InitWrapper.vue'),
        children: [
            {
                path: '',
                component: () => import('../wrappers/AdminRoleProvider.vue'),
                children: [
                    {
                        path: '',
                        name: 'homepage',
                        component: () => import('../views/HomePage/HomePage.vue'),
                        beforeEnter: authGuard,
                    },
                    ...applicationRoutes,
                ],
            },
            {
                path: 'auth',
                name: 'auth',
                beforeEnter: notAuthGuard,
                component: () => import('../views/Auth/Auth.vue'),
            },
            {
                path: 'terms',
                name: 'terms',
                component: () => import('../views/Terms/Terms.vue'),
            },
            {
                path: 'qa-tool',
                name: 'qa-tool',
                beforeEnter: authGuard,
                component: () => import('../views/QaTool/QaTool.vue'),
            },
            {
                path: 'reports',
                name: 'reports',
                component: () => import('../views/Reports/Reports.vue'),
            },
            ratingRoutes,
            moderationRoutes,
            {
                path: 'account',
                name: 'account',
                beforeEnter: authGuard,
                component: () => import('../Account/views/Account/Account.vue'),
            },
            {
                path: 'support',
                name: 'support',
                component: () => import('../views/Support/Support.vue'),
            },
            {
                path: 'referral',
                name: 'referral',
                beforeEnter: authGuard,
                component: () => import('../views/Referral/Referral.vue'),
            },
            {
                path: 'referral-policy',
                name: 'referral-policy',
                component: () => import('../views/ReferralPolicy/ReferralPolicy.vue'),
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
            }
        }

        if (savedPosition) {
            return savedPosition
        }

        return { top: 0 }
    },
})

export default router
